// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3zIIO","title":"styles_title__3w43Q","input":"styles_input__3emOf","newTeam":"styles_newTeam__2hm7u"};